import { render, staticRenderFns } from "./docRelational.vue?vue&type=template&id=7f310405&scoped=true"
import script from "./docRelational.vue?vue&type=script&lang=js"
export * from "./docRelational.vue?vue&type=script&lang=js"
import style0 from "./docRelational.vue?vue&type=style&index=0&id=7f310405&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f310405",
  null
  
)

export default component.exports